(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('Config', Config);

    Config.$inject = ['$resource'];

    function Config ($resource) {
        var resourceUrl =  'api/configs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
